module.exports = __webpack_public_path__ + "images/save-view-c8a9e79b.svg";